/**
 * Capitalisation for manually typed brand and model names (Jason, 2026-10-19).
 *
 * Reverb's catalog names are consistently cased, so pedals picked from the
 * typeahead look right. Manual entries ("daredevil pedals", "ic '77") did not,
 * and sat oddly beside them in browse. This capitalises the first letter of
 * every word and leaves the rest exactly as typed, so a model code written in
 * caps ("DS-1", "IC '77") or a deliberate lowercase run inside a word
 * ("ThorpyFX") survives. Applied only when no Reverb suggestion was picked.
 */
export function titleCaseWords(value) {
  if (typeof value !== 'string') return value;
  return value
    .trim()
    .replace(/\s+/g, ' ')
    .split(' ')
    // Only a word's FIRST character is touched; a word starting with a digit
    // or punctuation ("808-style", "'77") is left alone.
    .map((word) => word.replace(/^[a-z]/, (first) => first.toUpperCase()))
    .join(' ');
}
